export const endpoints = {
  REGION_FEEDBACK_VIEW: "/region/feedback/view",
}